import { performance } from 'perf_hooks';

class TimeUtils {
  public static startTimer = (): number => {
    return performance.now();
  };
}

export default TimeUtils;
